import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { SiteProvider } from './context/SiteContext';
import { SettingsProvider } from './context/SettingsContext';
import MaintenanceCheck from './components/MaintenanceCheck';
import SuperAdminDashboard from './pages/SuperAdminDashboard';
import SuperAdminTenants from './pages/SuperAdminTenants';
import SuperAdminParks from './pages/SuperAdminParks';
import SuperAdminAnalytics from './pages/SuperAdminAnalytics';
import SuperAdminSettings from './pages/SuperAdminSettings';
import SuperAdminPaymentGateways from './pages/SuperAdminPaymentGateways';
import PhonePeTspAdmin from './pages/PhonePeTspAdmin';
import TestTicketBooking from './pages/TestTicketBooking';
import ICICITest from './pages/ICICITest';
import PaymentTest from './pages/PaymentTest';
import MockPayment from './pages/MockPayment';
import PaymentSuccess from './pages/PaymentSuccess';
import PaymentFailed from './pages/PaymentFailed';
import PaymentStatus from './pages/PaymentStatus';
import ModernBooking from './pages/ModernBooking';
import TenantDashboard from './pages/TenantDashboard';
import TenantParks from './pages/TenantParks';
import TenantSettings from './pages/TenantSettings';
import TenantPaymentSettings from './pages/TenantPaymentSettings';
import TenantAnalytics from './pages/TenantAnalytics';
import TenantTickets from './pages/TenantTickets';
import TenantBookings from './pages/TenantBookings';
import TenantStaff from './pages/TenantStaff';
import SecurityDashboard from './pages/SecurityDashboard';
import TicketingStaffDashboard from './pages/TicketingStaffDashboard';
import StaffRoleGuard from './components/StaffRoleGuard';
import TenantAdminDashboard from './pages/TenantAdminDashboard';
import CustomerDashboard from './pages/CustomerDashboard';
import Login from './pages/Login';
import TicketBooking from './pages/TicketBooking';
import PublicBooking from './pages/PublicBooking';
import SitePage from './pages/SitePage';
import BookingStatus from './pages/BookingStatus';
import TermsOfService from './pages/TermsOfService';
import PrivacyPolicy from './pages/PrivacyPolicy';
import RefundPolicy from './pages/RefundPolicy';
import AboutUs from './pages/AboutUs';
import ContactSupport from './pages/ContactSupport';
import Presentation from './pages/Presentation';

import ParkAdmin from './pages/ParkAdmin';
import TenantSites from './pages/TenantSites';
import SuperAdminSites from './pages/SuperAdminSites';
import FunctionHallCalendar from './pages/FunctionHallCalendar';
import MonthlyPassManagement from './pages/MonthlyPassManagement';

function App() {
  return (
    <SettingsProvider>
      <MaintenanceCheck>
        <Router>
        <div className="App">
          <Routes>
          <Route path="/" element={<PublicBooking />} />
          <Route path="/login" element={<Login />} />
          <Route path="/book/:siteId" element={<PublicBooking />} />
          <Route path="/site/:siteId" element={<SitePage />} />
          <Route path="/book/:ticketId" element={<TicketBooking />} />
          <Route path="/booking/:bookingId" element={<BookingStatus />} />
          <Route path="/payment-success" element={<PaymentSuccess />} />
          <Route path="/payment-failed" element={<PaymentFailed />} />
          <Route path="/payment-status" element={<PaymentStatus />} />
          <Route path="/dashboard" element={<CustomerDashboard />} />
          <Route path="/super-admin" element={<SuperAdminDashboard />} />
          <Route path="/super-admin/tenants" element={<SuperAdminTenants />} />
          <Route path="/super-admin/parks" element={<SuperAdminParks />} />
          <Route path="/super-admin/analytics" element={<SuperAdminAnalytics />} />
          <Route path="/super-admin/payment-gateways" element={<SuperAdminPaymentGateways />} />
          <Route path="/super-admin/phonepe-tsp" element={<PhonePeTspAdmin />} />
          <Route path="/test-booking" element={<TestTicketBooking />} />
          <Route path="/icici-test" element={<ICICITest />} />
          <Route path="/payment-test" element={<PaymentTest />} />
          <Route path="/mock-payment" element={<MockPayment />} />
          <Route path="/modern-booking" element={<ModernBooking />} />
          <Route path="/test" element={<div>Test route working</div>} />
          <Route path="/test-booking-status/:bookingId" element={<BookingStatus />} />
          <Route path="/super-admin/settings" element={<SuperAdminSettings />} />
          <Route path="/tenant-dashboard" element={<SiteProvider><TenantDashboard /></SiteProvider>} />
          <Route path="/tenant-dashboard/sites" element={<SiteProvider><TenantSites /></SiteProvider>} />
          <Route path="/tenant-dashboard/analytics" element={<SiteProvider><TenantAnalytics /></SiteProvider>} />
          <Route path="/tenant-dashboard/tickets" element={<SiteProvider><TenantTickets /></SiteProvider>} />
          <Route path="/tenant-dashboard/bookings" element={<SiteProvider><TenantBookings /></SiteProvider>} />
          <Route path="/tenant-dashboard/staff" element={<SiteProvider><TenantStaff /></SiteProvider>} />
          <Route path="/tenant-dashboard/settings" element={<SiteProvider><TenantSettings /></SiteProvider>} />
          <Route path="/tenant/payment-settings" element={<SiteProvider><TenantPaymentSettings /></SiteProvider>} />
          <Route path="/tenant-dashboard/function-hall-calendar" element={<SiteProvider><FunctionHallCalendar /></SiteProvider>} />
          <Route path="/tenant-dashboard/monthly-passes" element={<SiteProvider><MonthlyPassManagement /></SiteProvider>} />
          <Route path="/security-dashboard" element={
            <StaffRoleGuard allowedRoles={['security', 'tenant_admin', 'super_admin']}>
              <SecurityDashboard />
            </StaffRoleGuard>
          } />
          <Route path="/staff-dashboard" element={
            <StaffRoleGuard allowedRoles={['ticketing', 'tenant_admin', 'super_admin']}>
              <TicketingStaffDashboard />
            </StaffRoleGuard>
          } />
          <Route path="/tenant-admin" element={<TenantAdminDashboard />} />
          <Route path="/park-admin" element={<ParkAdmin />} />
          <Route path="/tenant-dashboard/sites" element={<TenantSites />} />
          <Route path="/super-admin/sites" element={<SuperAdminSites />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/contact" element={<ContactSupport />} />
          <Route path="/terms" element={<TermsOfService />} />
          <Route path="/privacy" element={<PrivacyPolicy />} />
          <Route path="/refund" element={<RefundPolicy />} />
          <Route path="/presentation" element={<Presentation />} />
          </Routes>
        </div>
      </Router>
      </MaintenanceCheck>
    </SettingsProvider>
  );
}

export default App;